// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"414":"94be1de7","587":"d94e3dfb","615":"ede0251e"}[chunkId] + ".chunk.css";
};